(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["contact-form"] && !window.DesignMode) return;
  try {
    

function getIp(callback) {
    fetch('https://ipinfo.io/json?token=5b77f416738f57', {
        headers: {
            'Accept': 'application/json'
        }
    }).then((resp) => resp.json()).catch(() => {
        return {
            country: 'us'
        };
    }).then((resp) => callback(resp.country));
}

const phoneInputField = document.querySelector("#phone");
const phoneInput = window.intlTelInput(phoneInputField, {
    initialCountry: "auto",
    geoIpLookup: getIp,
    preferredCountries: [
        "mx",
        "us",
        "co"
    ],
	separateDialCode: "true",
	hiddenInput: "full_phone",
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
});


  } catch(e) { console.error(e); }
})();

})();
